import useUser from '../global/useUser';

function useBusiness() {
  const { user } = useUser();
  const isStudio = user?.business?.type === 'STUDIO';
  const isIndependent = user?.business?.type === 'INDEPENDENT';

  return {
    business: user?.business,
    isStudio,
    isIndependent,
  };
}

export default useBusiness;
